import { HAS_WINDOW } from '@eventbrite/feature-detection';
import loadable from '@loadable/component';
import React from 'react';

type AISearchModalProps = {
    isAISearchEnabled?: boolean;
    [x: string]: any;
};

export const AISearchModal = ({
    isAISearchEnabled,
    ...rest
}: AISearchModalProps) => {
    if (
        process.env.REACT_APP_TARGET === 'server' ||
        !HAS_WINDOW ||
        !isAISearchEnabled
    ) {
        return null;
    } else {
        const SmalltalkModal = loadable(
            () =>
                import(
                    /* webpackChunkName: 'smalltalk-lib' */
                    /* webpackMode: "eager" */
                    '@eventbrite/smalltalk-lib'
                ),
            {
                resolveComponent: (components: {
                    AISearchModal: React.ReactElement;
                }) => components.AISearchModal,
                ssr: false,
            },
        );

        return <SmalltalkModal {...rest} />;
    }
};
